
import { mapState, mapGetters } from "vuex";
import vClickOutside from "v-click-outside";
import { getCroppedImageUrl } from "~/common/helpers";

export default {
  name: "Comments",

  directives: {
    clickOutside: vClickOutside.directive,
  },

  data() {
    return {
      searchText: "",

      loading: false,

      dateFormatOptions: {
        year: "numeric",
        month: "short",
        day: "2-digit",
      },
    };
  },

  async fetch({ store }) {
    await store.dispatch("comments/retrieveCommentaries");
    await store.dispatch("comments/loadCityCodes");
  },

  head: {
    title: "Questions",

    meta: [
      {
        hid: "description",
        name: "description",
        content:
          "We bring to your attention only the best and proven models. Be confident in quality and efficiency",
      },
      {
        hid: "og:description",
        name: "og:description",
        content:
          "We bring to your attention only the best and proven models. Be confident in quality and efficiency",
      },
      {
        hid: "og:title",
        name: "og:title",
        content: "Emirates catalog",
      },
      {
        property: "og:image",
        hid: "og:image",
        name: "og:image",
        content: "https://erowall.com/wallpapers/large/3156.jpg",
      },
    ],
  },

  computed: {
    ...mapState(["profiles", "viewedModels", "menus"]),

    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      data: "comments/getAllComments",
      isMobile: "global/getMobileStatus",
      lastPage: "comments/getLastPage",
      currentPage: "comments/getCurrentPage",
      nextPage: "comments/getNextPage",
      countComments: "comments/getCountComments",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
    }),

    dataPagination() {
      let sortedArray = this.data;

      if (this.searchText.length) {
        sortedArray = sortedArray.filter((comment) => {
          return (
            comment.text.toLowerCase().includes(this.searchText) ||
            comment.profile.name.toLowerCase().includes(this.searchText) ||
            comment.profile.city.toLowerCase().includes(this.searchText)
          );
        });
      }

      return sortedArray;
    },

    sortedDataLength() {
      return this.dataPagination?.length || 0;
    },

    percentage() {
      return (this.sortedDataLength * 100) / this.countComments;
    },

    filterObj() {
      const districts =
        this.filtersList?.districts?.filter(
          (district) => district.city_id == this.currentCity.id
        ) || [];
      return {
        district: {
          items: districts,
          title: this.$t("area"),
        },
        gender: {
          items: [
            { title: this.$t("female"), id: "female" },
            { title: this.$t("shemale"), id: "transgender" },
            { title: this.$t("male"), id: "male" },
          ],
          title: this.$t("gender"),
        },
      };
    },

    districtsDroplist() {
      return (
        this.filterObj.district.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []
      );
    },

    genderDroplist() {
      return (
        this.filterObj.gender.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []
      );
    },
  },

  methods: {
    apply() {
      this.store.dispatch("comments/retrieveCommentaries");
    },

    async showMoreComments() {
      try {
        this.loading = true;

        await this.$store.dispatch("comments/loadCommentaries", this.nextPage);

        this.loading = false;
      } catch (e) {
        console.log(e);
      }
    },

    searchForText(key, value) {
      this.searchText = value;
    },

    commentsFilterModifier() {
      this.$store.commit("global/setCommentsFilter");
    },

    setFilter(key, value) {
      this.$store.commit("comments/setFilter", { key, value: value.value });
      this.$store.dispatch("comments/retrieveCommentaries");
    },

    setFilterMobile(data) {
      for (let key in data) {
        const value = data[key];
        if (value) {
          this.$store.commit("comments/setFilter", { key, value });
        }
      }
    },

    resetFilters() {
      this.$store.commit("comments/setFilters", {
        district: null,
        gender: null,
      });
      this.$store.dispatch("comments/retrieveCommentaries");
      this.commentsFilterModifier();
    },

    getCroppedImageUrl(fullImageUrl, size, discreetMode) {
      return getCroppedImageUrl(fullImageUrl, size, discreetMode);
    },
  },
};
